/* AutoShineX — prefetch internal pages on hover/touch intent so navigation feels instant.
 * When the user shows intent (hovers on desktop / touches on mobile) on a product card or
 * link, we fetch that page's HTML in the background. On click it's already cached → the next
 * page paints near-instantly. Only fetches HTML (rel=prefetch, no execution) so there are NO
 * analytics/JS side-effects. Same-origin only; skips cart/checkout/account; respects Data Saver;
 * capped to avoid wasting mobile data.
 */
(function () {
  'use strict';

  var conn = navigator.connection;
  // Respect Data Saver and very slow networks — don't spend their data speculatively.
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

  var done = new Set();
  var MAX = 12;
  var hoverTimer;

  function eligible(a) {
    if (!a || !a.href || a.hasAttribute('data-no-prefetch')) return null;
    if (a.target && a.target !== '_self') return null;
    if (a.getAttribute('href') && a.getAttribute('href').charAt(0) === '#') return null;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    if (u.pathname === location.pathname) return null;
    if (/\/(cart|checkout|account)(\/|$|\?)/.test(u.pathname)) return null;
    if (done.has(u.href)) return null;
    return u.href;
  }

  function prefetch(url) {
    if (done.size >= MAX || done.has(url)) return;
    done.add(url);
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = url;
    l.as = 'document';
    document.head.appendChild(l);
  }

  // Desktop: hover intent, with a small delay so a quick pass-over doesn't trigger a fetch.
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    var url = eligible(a);
    if (!url) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { prefetch(url); }, 70);
  }, { passive: true });
  document.addEventListener('mouseout', function () { clearTimeout(hoverTimer); }, { passive: true });

  // Mobile: touchstart = real tap intent → gives the fetch a ~100ms head start before the click resolves.
  document.addEventListener('touchstart', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    var url = eligible(a);
    if (url) prefetch(url);
  }, { passive: true });
})();
